import React, {useEffect, useState} from 'react';
import {PlusIcon} from "../../../Assets/svg";
import _axios from "../../../httpService";
import ErrorHandler from "../../ErrorHandler";
import {prefixUrl} from "../../../utils/utilsData";
import {ModalToRoot} from "../../../Modal/ModalToRoot";
import SectionViewModal from "../../Setting/Permissions/SectionViewModal";
import AddNewGroupModal from "./AddNewGroupModal";
import objectDataHolder from "../../Hooks/ObjectDataHolder";
import {toast} from "react-toastify";
import {useDispatch, useSelector} from "react-redux";
import {submitDocumentFormAction} from "../../Store/SubmitDocumentForm";

const AddNewDocType = (props) => {

  const sendData = useSelector(s => s.submitDocumentFormReducer);
  const dispatch = useDispatch()

  const [reload, setReload] = useState(150);

  const [list, setList] = useState([])
  useEffect(() => {
    _axios.get(prefixUrl() + `/accountingGroups/?request=documentGroups`).then(res => {

      if (res.data.status) {
        setList(res.data.data)
      }

    })
  }, [reload]);
  const [modal, setModal] = objectDataHolder({
    isOpen: false,
  })



  const modalSubmit = (newGroup) => {

    const data = {
      request: `newDocumentGroups`,
      groupName: newGroup
    }
    _axios.post(prefixUrl() + `/accountingGroups/?request=newDocumentGroups`, data).then(res => {

      if (res.data.status) {

        toast.success(res.data.message)
        setModal({isOpen: false})
        setReload(reload + 1);
      }
    })
  }
  try {
     return (
      <>
        <div className={"input__label width__210"}>
          <label htmlFor={"dateHereForm"}>نوع سند</label>

          <select
            value={sendData.groupId}
            onChange={e => dispatch(submitDocumentFormAction.fillInput({groupId:e.target.value}))}
          >
            <option value={''}>انتخاب کنید</option>
            {list.map((v, index) => <option key={index} value={v.groupId}>{v.groupName}</option>)}
          </select>
          <div
            className={'cursor__pointer'}
            style={{
              position: "absolute",
              top: 6,
              left: 4,
              background: `#fff`,
            }}
            onClick={() => setModal({isOpen: true})}
          ><PlusIcon/>
          </div>
        </div>
        {modal.isOpen && <ModalToRoot
          // title={modal.data.FaLabel}
          // onClickCloseFunction={() => setModal({isOpen: false})}
        >
          <AddNewGroupModal isOpen={modal.isOpen}
                            setIsOpen={setModal}
                            modal={modal}
                            onSubmit={modalSubmit}/>
        </ModalToRoot>}


      </>
    );
  } catch (error) {
    return <pre>{error?.message}</pre>
  }

};

export default AddNewDocType;
